import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";

const app = <App />;

ReactDOM.render(app, document.getElementById("root"));
